<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['factoryCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="factoryCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.factoryCode"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvOnhandQuantitiesNewExport" ref="download" />
        <a-button type="primary" @click="handleExport" v-hasPermi="['inv:invOnhandQuantities:timelyDeliveryRateExport']">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.FINISHED_PRODUCTS_DELIVERY_RATE_LIST, // 表格方案配置唯一值
              }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetTimelyDeliveryRateList, apiInvOnhandQuantitiesNewExport } from '@/api/report/finished-products-delivery-rate'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Finished-products-delivery-rate', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiInvOnhandQuantitiesNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetTimelyDeliveryRateList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        tenantId: undefined,
        factoryCode: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr07: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '子库编码',
          decorator: ['tenantId'],
          type: 'input'
        },
        {
          label: '组织编码',
          decorator: ['factoryCode'],
          type: 'factoryCode'
        },
        {
          label: '物料编码',
          decorator: ['skuKey'],
          type: 'input'
        },
        {
          label: '物料名称',
          decorator: ['skuName'],
          type: 'input'
        },
        {
          label: '工单号',
          decorator: ['attr07'],
          type: 'input'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '子库编码',
          dataIndex: 'tenantId',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织编码',
          dataIndex: 'factoryCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'attr07',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'skuKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'skuName',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specModel',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '已入库数量',
          dataIndex: 'qtyRev',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '实际出库数量',
          dataIndex: 'shipQty',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '正常',
          dataIndex: 'normal',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '延期',
          dataIndex: 'postpone',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '未出库数量占比',
          dataIndex: 'noShipQty',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created () {
    // 处理缓存逻辑
    this.getHistoryCache('refSearchForm', 'factoryCode')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        tenantId: undefined,
        factoryCode: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr07: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.download('inv/invOnhandQuantities/timelyDeliveryRateExport', this.$refs.dataTable.searchParams, `组装中心成品出库及时率_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less"></style>
